const fetchUsers = async (params) => {
	try {
		return await axios.get('/researchers', {
			params,
		})
	}
	catch(e) {
		throw e
	}
}

const fetchActivities = async (params) => {
	try {
		return await axios.get('/activities/subject', {
			params,
		})
	}
	catch (e) {
		throw e
	}
}

const generatePassword = async ({ user }) => {
	try {
		return await axios.post(`/user/${user}/generate/password`)
	}
	catch (e) {
		throw e
	}
}

const addPublicationExternalResearcher = async({
	user,
  }) => {
	try {
		return await axios.post(
			`publication/external-researcher`,
			user
		)
	} catch (e) {
		throw e
	}
}

export {
	fetchUsers,
	fetchActivities,
	generatePassword,
	addPublicationExternalResearcher,
}
